export default __webpack_public_path__ + "static/media/Avatar-23.0287d650.png";